import { createSelector } from '@ngrx/store';
import { creditCardsState } from '../root';

export const getCardsData = createSelector(creditCardsState, (creditCards) => creditCards.data || []);
